import { Box, Typography } from "@mui/material";
import { STAGE_LABELS, STAGE_ORDER } from "../../utils/constants";

interface LogicChainTimelineProps {
  stage: string;
}

export default function LogicChainTimeline({ stage }: LogicChainTimelineProps) {
  const currentIdx = STAGE_ORDER.indexOf(stage as (typeof STAGE_ORDER)[number]);

  return (
    <Box>
      <Typography variant="caption" sx={{ color: "#A99F8E", fontWeight: 600 }}>
        对话阶段
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1, flexWrap: "wrap" }}>
        {STAGE_ORDER.map((s, idx) => {
          const isCurrent = s === stage;
          const isPast = idx < currentIdx;
          const label = STAGE_LABELS[s] || s;

          return (
            <Box key={s} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <Box
                sx={{
                  px: 1,
                  py: 0.3,
                  borderRadius: 1,
                  backgroundColor: isCurrent
                    ? "#7C6F5C"
                    : isPast
                    ? "#7C6F5C20"
                    : "#E8E2D9",
                  color: isCurrent ? "#FFF" : isPast ? "#7C6F5C" : "#A99F8E",
                  fontSize: "0.7rem",
                  fontWeight: isCurrent ? 600 : 400,
                  transition: "all 0.3s ease",
                }}
              >
                {label}
              </Box>
              {idx < STAGE_ORDER.length - 1 && (
                <Box
                  sx={{
                    width: 12,
                    height: 2,
                    backgroundColor: isPast ? "#7C6F5C40" : "#E8E2D9",
                  }}
                />
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
